import { render, staticRenderFns } from "./resetPassword.vue?vue&type=template&id=5fc78fad&scoped=true"
import script from "./resetPassword.vue?vue&type=script&lang=js"
export * from "./resetPassword.vue?vue&type=script&lang=js"
import style0 from "./resetPassword.vue?vue&type=style&index=0&id=5fc78fad&prod&lang=scss&scoped=true"
import style1 from "./resetPassword.vue?vue&type=style&index=1&id=5fc78fad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc78fad",
  null
  
)

export default component.exports